export { default as clamp } from 'lodash/clamp';
export { default as debounce } from 'lodash/debounce';
export { default as get } from 'lodash/get';
export { default as isEmpty } from 'lodash/isEmpty';
export { default as isEqual } from 'lodash/isEqual';
export { default as padStart } from 'lodash/padStart';
export { default as moment } from 'moment';

export const isDesktop = (screenSize = 0) => screenSize >= 768;

export const isInStandaloneMode = () =>
  window !== undefined &&
  (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);
